import { RoleRoute, RoleRouteObject } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import { faDumpster } from '@fortawesome/free-solid-svg-icons'
import DumpsPage from '@/routes/dumps/DumpsPage'
import DumpEditorRoute from '@/routes/dumps/DumpEditor.route'

export const DumpsPageRoute: RoleRoute = {
  path: 'dumps',
  children: [
    {
      index: true,
      element: <DumpsPage />,
      allowedRoles: [Roles.GlobalAdministrator, Roles.TechDeveloper],
    } as RoleRouteObject,
    DumpEditorRoute,
  ],
  errorElement: <RouterErrorHandler />,
  text: 'Dump',
  faIcon: faDumpster,
  mainMenuRoute: true,
  handle: {
    crumb: () => ({
      label: 'Dump',
      icon: faDumpster,
    }),
  },
  allowedRoles: [Roles.GlobalAdministrator, Roles.TechDeveloper],
}
